import {createBorder} from '../../common';

declare const THREE: any;

export class Step extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));

  constructor(width: number, height: number) {
    const geometry = new THREE.PlaneBufferGeometry(width, height).applyMatrix(Step.rotationTransform);
    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide
    });
    super(geometry, material);
    const border = createBorder(geometry.clone());
    this.add(border);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Stairs/Step.ts